import { h, Component } from 'preact';
import { Router, route } from 'preact-router';
import createHashHistory from 'history/createHashHistory';


import ChannelComponent from './ChannelComponent';
import style from './style.css';
import axios from 'axios';

if (module.hot) {
	require('preact/debug');
}

class Redirect extends Component {
  componentWillMount() {
    const { number } = this.props

    if (!isNaN(number)) {
      route(`/ch/${number}`);
    } else {
      route(this.props.to, true);
    }
  }

  render() {
    return null;
  }
}

window.onload = function() {
	setTimeout(function(){

		document.getElementById('load').style.display = 'none';
		
	}, 600); 
	document.getElementById('app').style.display = 'block';
};

export default class App extends Component {

  componentWillMount() {
    const { pathname, href } = window.location
     if (!href.includes('#')) {
      history.replaceState('data to be passed', 'Title of the page', '/#' + pathname);
    }
  }

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
	};

	

	render() {
		return (
			<div id="app" class={style.all}>
			
			<div id="load" class={style.notoaded} >
			<div class={style.inload}>
			<img src="assets/gui.png"  />
			</div>
			</div>
			<a class={style.home} href="https://kidsuper.com/">kidsuper.com</a>
			<div class={style.loaded}>   
			<div class={style.buddy}> 
		
			<div class={style.buddy__ratio}></div>
			<div class={style.tvOverlay}></div> 
			 <Router history={createHashHistory()} onChange={this.handleRoute}  >
          <ChannelComponent path="ch/:channel" />
          <Redirect path="/:number" to="ch/1" />
          <Redirect path="/" to="ch/1" />
        </Router>
				</div>	</div>
		</div>
		    

		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js